// eslint-disable-next-line no-shadow
export enum MusicVideoGenerateActions {
	RE_SUBMIT = 're-submit',
	START = 'start',
}
